import { TranslationKey } from "@impero-com/common/types/i18n";

import { WebRoute } from "../../routes";

/**
 * Source of truth for the `/users/:id` sub-pages
 *
 * - `title` — the app bar / document title, matching what each page passes today.
 * - `path` — the URL segment, which doubles as the side menu item's id.
 */
export const USER_SUBPATHS = {
    GROUPS: {
        title: "User_Groups",
        path: "groups",
    },
    CONTROLS: {
        title: "User_Controls",
        path: "controls",
    },
    PROGRAMS: {
        title: "User_ControlPrograms",
        path: "programs",
    },
    DIRECT_CONTROL_RESULTS: {
        title: "User_PendingActivities",
        path: "direct-control-results",
    },
    GROUP_CONTROL_RESULTS: {
        title: "User_PendingActivities",
        path: "group-control-results",
    },
    TESTING_PROGRAMS: {
        title: "User_TestingPrograms",
        path: "testing-programs",
    },
    TESTING_ACTIVITIES: {
        title: "User_TestingActivities",
        path: "testing-activities",
    },
    TESTING_CONTROLS: {
        title: "User_TestingControls",
        path: "testing-controls",
    },
    RISK_DIRECTORIES: {
        title: "User_RiskDirectories",
        path: "risk-directories",
    },
    RISK_ENTITIES: {
        title: "RiskEntities_Title",
        path: "risk-entities",
    },
    CONTROL_ENTITIES: {
        title: "User_Entities",
        path: "control-entities",
    },
    CUSTOM_REPORTS: {
        title: "User_CustomReports",
        path: "custom-reports",
    },
    PUSH_REPORTS_RESPONSIBLE: {
        title: "User_PushReports_Responsible",
        path: "push-reports-responsible",
    },
    PUSH_REPORTS_RECIPIENT: {
        title: "User_PushReports_Recipient",
        path: "push-reports-recipient",
    },
} as const satisfies Record<string, { title: TranslationKey; path: string }>;

/** Title for the index route (/users/:id) and any non-segment path. */
export const USER_VIEW_DEFAULT_TITLE =
    "UserManagement_ModuleTitle" satisfies TranslationKey;

/** The parameterised user route, e.g. "/users/:id". Reused by ORG_PARAM_PATHS. */
export const USER_ID_PATH = `${WebRoute.USERS}/:id` as const;

/**
 * Look up a sub-page by its URL segment (e.g. from a hash or the active path).
 * Returns undefined for an unknown segment.
 */
export const findUserSubpath = (path: string) =>
    Object.values(USER_SUBPATHS).find((subpath) => subpath.path === path);
